var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#2c3e50",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 9h16.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 15h16.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3a17 17 0 0 0 0 18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3a17 17 0 0 1 0 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.05808ec45dd9b8604da6fcfa6711025c.svg";
export { ForwardRef as ReactComponent };